import { apiSlice } from '../../../setup/api/api.slice';
import { DataResponseOfPublicCheckInResponse, PublicTokenResponse } from '../../../typings/generated/careerhub-client';
import { PublicCheckInRequestOverride, PublicCheckInUndoRequestOverride, PublicTokenRequest } from '../models/public-token.model';

export const publicTokenEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        publicToken: builder.query<PublicTokenResponse, PublicTokenRequest>({
            query: request => `token/${request.token}`,
        }),
        publicCheckIn: builder.mutation<DataResponseOfPublicCheckInResponse, PublicCheckInRequestOverride>({
            query: request => ({
                url: `token/${request.token}/checkin`,
                method: 'POST',
                body: { value: request.value },
            }),
        }),
        publicCheckInUndo: builder.mutation<undefined, PublicCheckInUndoRequestOverride>({
            query: request => ({
                url: `token/${request.token}/checkin/undo`,
                method: 'POST',
                body: { value: request.value, undoToken: request.undoToken },
            }),
        }),
    }),
});

export const {
    usePublicTokenQuery,
    usePublicCheckInMutation,
    usePublicCheckInUndoMutation,
} = publicTokenEndpoints;
